import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export const requestSlice = createSlice(
{
    name: 'api_request',
    initialState: 
    {
        /**
         * Indicates that the last request didn't reach the backend server.
         * If a subsequent request succeeds, resets to false.
         */
        backendUnreachable: false,
        /**
         * If there are any ongoing requests, all form fields and buttons are disabled.
         */
        ongoingRequestCount: 0,
    },
    reducers:
    {
        setBackendUnreachable: function(state, action: PayloadAction<boolean>)
        {
            state.backendUnreachable = action.payload;
        },
        incrementOngoingRequests: function(state)
        {
            state.ongoingRequestCount++;
        },
        decrementOngoingRequests: function(state)
        {
            state.ongoingRequestCount--;
        }
    },
});

export const requestActions = requestSlice.actions;
export const requestReducer = requestSlice.reducer;